import { render, staticRenderFns } from "./trainingCourses.vue?vue&type=template&id=df38115e&scoped=true&"
import script from "./trainingCourses.vue?vue&type=script&lang=ts&"
export * from "./trainingCourses.vue?vue&type=script&lang=ts&"
import style0 from "./trainingCourses.vue?vue&type=style&index=0&id=df38115e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df38115e",
  null
  
)

export default component.exports